// extracted by mini-css-extract-plugin
export default {"layout":"master_layout__5Uw6C","content":"master_content__1M+dS"};